module.exports = __webpack_public_path__ + "static/media/47.9c9061be.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/47.png
// module id = 619
// module chunks = 0